
<main role="main" class="not-home-page">
    <div class="container">
        <div class="row">
            <!-- <div class="col-12" *ngIf="!showAllPort">
             
                <a href="javascript:void(0)" (click)="topImage = true" [routerLink]="['/services/portmaroc']"
                ><i class="fa fa-reply"    style=" font-size: 22px;"></i></a
              >
            </div> -->
            <div class="row">
                <div class="row" *ngIf="showAllPort" >
                    <div class="col-lg-3 col-md-3 col-xs-12 col-sm-12">
                
                    </div>
                    <div class="col-lg-9 col-md-9 col-xs-12 col-sm-12">
                        <ol>
                            <li *ngFor="let region of regions"> {{region | translate}}
                                <ul>
                                    <li *ngFor="let port of ports | filterTab: region">
                                        <a [routerLink]="['/port', port.pathPort]" (click)="currentBanniere=port.img" routerLinkActive="router-link-active" >
                                       {{port.port | translate}}</a> 
                                    </li>
                                </ul>
                        
                            </li>
                        </ol>
                    </div>
                 
                   
                </div>
                <div class="row" *ngIf="!showAllPort">
                    <div class="col-12">
                       
                           <div class="col-12">
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><a href="javascript:void(0)" [routerLink]="['/']" routerLinkActive="router-link-active" >{{"general.Accueil" | translate}}</a></li>
                                <li class="breadcrumb-item"><a href="javascript:void(0)" [routerLink]="['/portmaroc']" routerLinkActive="router-link-active">{{ "general.portMaroc" | translate}}</a></li>
                                <li class="breadcrumb-item active" >{{ this.selectedPort  | translate}}</li>
                                </ol>
                             </nav>    
                           </div>
                        
                              <div class="col-12">
                                <h2>{{ this.selectedPort  | translate}}</h2>
                            </div>          
                      
                          </div>
                    
                  
                      <div class="col-12">
                          <div class="row">
                           
                            <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                              <img [src]="currentBanniere"  style="margin-bottom: 20px;width:100%">
                          </div>
          
                          </div>
                 
                      </div>
                      <div class="col-12">
                          <div class="row">
                            <div class="col-lg-3 col-md-3 col-xs-12 col-sm-12">
                                <nav id="sidebar">
                                    <ul class="nav flex-column" >
                                        <li class="nav-item" *ngFor="let menu of menuPort">
                                           <a [class.textRight]="isArab" class="nav-link btn btn-info" href="javascript:void(0)" 
                                           [class.active]="(menu.url !== null) && (currentUrl.toLowerCase().indexOf(menu.url.toLowerCase()) != -1)"
                                           [routerLink]="['page',menu.url]" routerLinkActive="router-link-active" (click)="currentUrl = menu.url" >{{menu.title}}</a> 
                                        </li>
                                    </ul>
                                </nav>
                         
                            </div>
                            <div class="col-lg-9 col-md-9 col-xs-12 col-sm-12">
                 
                               
                                    <router-outlet></router-outlet>
                               
                               
                            </div>
                          </div>
                 
                      </div>
             
             
                </div>
            </div>
                   
                    
            
         
            
            
            
        </div>
    </div>
    </main>

